export default "__VITE_ASSET__CwCoirug__"